<script lang="ts">
	import { onMount, getContext } from "svelte";
	export let component: string = null;
	export let props: { [key: string]: any };
	export let hydrate = true;

	//	set by the islands runtime (www/src/islands/entry.ts) when it mounts a
	//	component: the marker was already consumed, so render the content
	//	directly and never swap branches post-mount (the swap tears down
	//	bind:this refs while observers/reactive statements still fire);
	//	absent during SSR and in admin, where behavior is unchanged
	const islandRuntime = getContext("islandRuntime");

	const c: SvelteStore<number | null> = getContext("parentBlockColumnCount");
	const b: SvelteStore<string | null> = getContext(
		"parentBlockBackgroundColor"
	);

	const setContext: any = {
		parentBlockColumnCount: {
			value: $c,
			type: "store/readable",
		},
		parentBlockBackgroundColor: {
			value: $b,
			type: "store/readable",
		},
	};

	let mounted = false;
	onMount(() => (mounted = true));
</script>

{#if islandRuntime || mounted || !hydrate}
	<slot />
{:else}
	<div
		class="_hydratable"
		data-props={encodeURIComponent(JSON.stringify(props))}
		data-context={encodeURIComponent(JSON.stringify(setContext))}
		data-component={component}
	>
		<slot />
	</div>
{/if}
